import { useState, useEffect, useRef } from "react";
import Link from "next/link";
import { event as gaEvent } from "~/lib/ga";

const rotatingBanners = [
  {
    id: 1,
    img: "/images/revista/banner_jpremium.jpeg",
    link: "https://seminuevossonora.com/negocios/jpremium_automotriz",
    alt: "JPremium Automotriz"
  },
  {
    id: 2,
    img: "/images/revista/cortinas_metalicas_26.jpeg",
    link: "https://cortinasmetalicasgarcia.com.mx",
    alt: "Cortinas metalicas",
    targetBlank: true 
  },
  {
    id: 3,
    img: "/images/revista/anuncia_negocio_26.jpeg",
    link: "https://wa.me/+5216221001003?text=Quisiera%20mas%20informacion%20sobre%20como%20anunciar%20mi%20negocio",
    alt: "Anuncia tu negocio"
  },
];

export default function LocalAds() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const timerRef = useRef(null);

  // ============================================================
  // EFECTO NUEVO: Define una posición aleatoria al entrar al sitio
  // ============================================================
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * rotatingBanners.length);
    setCurrentIndex(randomIndex);
  }, []);

  // Lógica existente para rotar automáticamente cada 8 segundos
  useEffect(() => {
    if (isPaused) return;

    timerRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % rotatingBanners.length);
    }, 7200);

    return () => clearInterval(timerRef.current);
  }, [isPaused]);

  const currentBanner = rotatingBanners[currentIndex];

  // Control preventivo por si el estado aún no se sincroniza
  if (!currentBanner) return null;

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <div>
        <h5 className="text-lg text-gray-900 mb-2">Anuncios</h5>

        {/* Contenedor con eventos para pausar al pasar el mouse */}
        <div 
          onMouseEnter={() => setIsPaused(true)} 
          onMouseLeave={() => setIsPaused(false)}
        >
          <Link href={currentBanner.link}>
            <a
              onClick={() => {
                gaEvent({
                  action: "revista_banner_click",
                  params: { banner_id: currentBanner.id },
                });
              }}
              // La clase opacity-0 a opacity-100 con duration crea el fade
              className="block transition-opacity duration-1000 ease-in-out"
              target={currentBanner.targetBlank ? "_blank" : undefined}
            >
              <img
                src={currentBanner.img}
                alt={currentBanner.alt}
                // Key asegura que React fuerce la re-animación al cambiar de imagen
                key={currentBanner.id} 
              />
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}